import React, { Component } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import { Logo, H1, H2, Note, Button, Icon } from '../Common'

import cool from '../../images/emojis/cool.svg'

import style from './Thanks.scss'

class Thanks extends Component {
  static propTypes = {
    search: PropTypes.shape({
      url: PropTypes.string,
      mobile: PropTypes.string,
    }),
  }

  state = { time: 5 }

  UNSAFE_componentWillMount() {
    const { url, mobile } = this.props.search
    this.setState((state) => ({
      ...state,
      url,
      mobile: mobile === 'true',
    }))
  }

  componentDidMount() {
    if (!this.state.mobile) {
      this.updateTime()
    }
  }

  updateTime = () => {
    if (this.state.time === 0) {
      const url = this.state.url
      window.location.href = url
      return
    }
    this.setState(
      (state) => ({
        time: state.time - 1,
      }),
      () => {
        setTimeout(this.updateTime, 1000)
      },
    )
  }

  render() {
    const { time, url, mobile } = this.state

    if (mobile) {
      return (
        <div className={cx(style.wrapper, style.mobile)}>
          <Logo className={style.logo} />
          <div className={style.container}>
            <H2 className={style.title}>sucesso!</H2>
            <p>Nossa equipe acaba de lhe enviar um e-mail com as boas vindas para a Hi Platform!</p>
            <div className={style.background}>
              <H2 className={style.subtitle}>
                para acessar a plataforma você precisa <span>usar um tablet ou computador.</span>
              </H2>
              <a href="https://www.hiplatform.com/" className={style.link}>
                <Icon value="chevron_left" material /> voltar ao site
              </a>
            </div>
          </div>
        </div>
      )
    }

    return (
      <div className={style.wrapper}>
        <Logo className={style.logo} />
        <div className={style.container}>
          <img src={cool} alt="Emoji Feliz!" />
          <H1>sucesso!</H1>
          <p>Nossa equipe acaba de lhe enviar um e-mail com as boas vindas para a Hi Platform!</p>
          <Button href={url} xl>
            começar a usar
          </Button>
          <Note show={time > 0}>
            redirecionamento automático em {time} {time > 1 ? 'segundos' : 'segundo'}
          </Note>
        </div>
      </div>
    )
  }
}

export default Thanks



// WEBPACK FOOTER //
// ./src/components/Thanks/Thanks.js